export default "__VITE_ASSET__uAtd0GpZ__"